import script from "./CustomFileInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFileInput.vue?vue&type=script&setup=true&lang=js"

import "./CustomFileInput.vue?vue&type=style&index=0&id=3eb8089a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb8089a"]])

export default __exports__